<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>
          <OLoadingDialog :value="isLoading" />

          <EditSetDialog ref="editDialog" />

          <v-card>
            <v-toolbar class="card-bar">
              <v-toolbar-title>Audio Sets</v-toolbar-title>
              <v-btn icon class="ml-5" @click="reload">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn color="primary" @click="newRow()">Novo Set...</v-btn>
            </v-toolbar>

            <ODataTable
              :spec="spec"
              :items="rows"
              :disableInitialSort="true"
              @rowClicked="selectRow"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { AudioSet } from '@/models'
import { brDateTime } from 'oderon-commons/src/formatters'

let color = 'grey--text text--lighten-1',
  grey = x => ({ html: `<span class="${color}">${x}</span>` })

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    EditSetDialog: require('./EditSetDialog').default
  },
  data() {
    return {
      isLoading: false,
      rows: [],
      spec: [
        { t: 'ID|', d: 'id', f: grey, w: 85 },
        { t: 'Nome', d: 'name' },
        { t: 'Criado|', d: 'createdAt', f: brDateTime, w: 200 },
        { t: 'Atualizado|', d: 'updatedAt', f: brDateTime, w: 200 }
      ]
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.rows = await AudioSet.findAll()
    },

    async newRow() {
      let name = await this.$prompt({
        label: 'Nome do AudioSet:'
      })

      if (name != null) {
        this.$loading(async () => {
          let created = await AudioSet.save({ name })
          await this.fetchData()
          this.selectRow(created)
        })
      }
    },

    async selectRow(r) {
      let res = await this.$refs.editDialog.open(r && r.id)

      if (res === 'DELETE') {
        return this.confirmDelete(r)
      }

      if (res != null) {
        this.$loading(async () => {
          await AudioSet.save(res)
          await this.fetchData()
          this.$snack('Salvo com sucesso')
        })
      }
    },

    async confirmDelete(r) {
      let result = await this.$confirm({
        message: `Deseja remover o AudioSet ${r.name}?`,
        okText: 'Sim, remover',
        cancelText: 'Não, Cancelar'
      })

      if (result) {
        this.$loading(async () => {
          await AudioSet.delete(r.id)
          await this.fetchData()
          this.$snack('Removido com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
